export default "__VITE_ASSET__2f402683__"